import { component as defineComponent } from 'flightjs';
import withButtonStates from 'entry/mixins/with-button-states';
import Consts from 'entry/consts/button-states';

function likeButton() {
    this.attributes({
        likeCounter: '[data-like-count]',
        likeButton: '[data-like-button]',
    });

    this.incrementLikeCount = function (e) {
        var counter = this.select('likeCounter');
        var countValue = parseInt(counter.text(), 10);
        countValue++;
        counter.text(countValue);
        counter.removeAttr('data-hidden');
        this.trigger('uiLikeCountUpdated', { likes: countValue });
    };

    this.decrementLikeCount = function () {
        var counter = this.select('likeCounter');
        var countValue = parseInt(counter.text(), 10);

        if (countValue > 0) {
            countValue--;
            counter.text(countValue);
        }

        if (countValue < 1) {
            counter.attr('data-hidden', true);
        }

        this.trigger('uiLikeCountUpdated', { likes: countValue });
    };

    this.like = function () {
        this.updateActionButtonState('likeButton', Consts.STATE_ACTIVE);
    };

    this.unlike = function () {
        this.updateActionButtonState('likeButton', Consts.STATE_INACTIVE);
    };

    this.triggerLike = function () {
        var button = this.select('likeButton'),
            state = button.data('state');

        if (button.is('[data-disabled]')) {
            return;
        }

        if (state === Consts.STATE_ACTIVE) {
            this.triggerActionEvent('likeButton', 'uiUnlikeEntryRequested');
        } else if (state === Consts.STATE_INACTIVE) {
            this.triggerActionEvent('likeButton', 'uiLikeEntryRequested');
        }
    };

    this.triggerShowLikers = function (e) {
        e.stopPropagation();
        this.trigger('uiShowLikersRequested');
    };

    this.after('initialize', function () {
        this.on('click', {
            likeCounter: this.triggerShowLikers,
            likeButton: this.triggerLike,
        });

        this.on('uiLikeEntryRequested', this.like);
        this.on('uiLikeEntryRequested', this.incrementLikeCount);
        this.on('uiUnlikeEntryRequested', this.unlike);
        this.on('uiUnlikeEntryRequested', this.decrementLikeCount);
    });
}

export default defineComponent(likeButton, withButtonStates);



// WEBPACK FOOTER //
// ./src/web/js/entry/ui/like-button.js